import { collection, deleteField, doc, getDoc, getDocs, runTransaction, updateDoc } from 'firebase/firestore';
import type { UserAccountDoc } from '@flintmint/core-shared/firestore/schemas';
import { getFirestore } from './firebase-service';

const COLLECTION_NAME = 'userAccounts';

export const fetchAllUserAccounts = async (): Promise<UserAccountDoc[]> => {
  const firestore = getFirestore();
  const snapshot = await getDocs(collection(firestore, COLLECTION_NAME));
  return snapshot.docs.map((docSnap) => docSnap.data() as UserAccountDoc);
};

export const fetchUserAccount = async (userId: string): Promise<UserAccountDoc | null> => {
  const firestore = getFirestore();
  const snapshot = await getDoc(doc(firestore, COLLECTION_NAME, userId));
  return snapshot.exists() ? (snapshot.data() as UserAccountDoc) : null;
};

/**
 * Merge-writes `compedAt` and the first `trialUsedAt`: creates the doc for a user with none, updates it otherwise.
 * Returns the `compedAt` written, which is also the `updatedAt` written.
 */
export const compUser = async (userId: string): Promise<string> => {
  const firestore = getFirestore();
  const now = new Date().toISOString();
  const ref = doc(firestore, COLLECTION_NAME, userId);
  await runTransaction(firestore, async (transaction) => {
    const account = (await transaction.get(ref)).data() as UserAccountDoc | undefined;
    transaction.set(ref, { userId, compedAt: now, trialUsedAt: account?.trialUsedAt ?? now, updatedAt: now }, { merge: true });
  });
  return now;
};

export const endUserComp = async (userId: string): Promise<void> => {
  const firestore = getFirestore();
  await updateDoc(doc(firestore, COLLECTION_NAME, userId), {
    compedAt: deleteField(),
    updatedAt: new Date().toISOString(),
  });
};
